import client from 'api/graphQL/config'
import {gql, TypedDocumentNode} from '@apollo/client'
import {HomeStatsArgsType} from 'commonTypes'
import {Query} from 'graphql-api'

const GET_TAB_COUNTS: TypedDocumentNode<Query> = gql`
  query GetTabCounts {
    databases {
      databaseId
    }

    jobs(first: 1) {
      totalCount
    }

    jobRequests(first: 1) {
      totalCount
      nodes {
        requestId
      }
    }
  }
`

const GET_HOME_STATS: TypedDocumentNode<Query> = gql`
  query getHomeStats(
    $databaseIds: [UUID!],
    $jobsStatuses: [JobStatus!]
  ) {
    jobStatusCount(
      databaseIds: $databaseIds
      jobsStatuses: $jobsStatuses
    ) {
      status
      count
    }

    jobCountByType (
      databaseIds: $databaseIds
      jobsStatuses: $jobsStatuses
    ) {
      jobType
      count
    }

    jobCountByUrl(
      databaseIds: $databaseIds
      jobsStatuses: $jobsStatuses
    ) {
      label
      count
    }

    databaseCountByAppVersion {
      label
      count
    }

    databaseCountByDatabaseVersion {
      label
      count
    }
  }
`

export const getTabCounts = () => client.query({query: GET_TAB_COUNTS})

export const getHomeStats = (
  where: HomeStatsArgsType
) => client.query({
  query: GET_HOME_STATS,
  variables: where,
})
